module.exports = __webpack_public_path__ + "static/media/wordmark-white.97046bf1.svg";